import { supabase } from './supabase';

export type AuthError = {
  message: string;
};

export async function signUp(email: string, password: string) {
  try {
    console.log('Attempting to sign up user:', email);
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    });
    
    if (error) {
      console.error('Sign up error:', error);
      throw error;
    }
    console.log('Sign up successful:', data);
    return data;
  } catch (err) {
    console.error('Sign up failed:', err);
    throw err;
  }
}

export async function signIn(email: string, password: string) {
  try {
    console.log('Attempting to sign in user:', email);
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    
    if (error) {
      console.error('Sign in error:', error);
      throw error;
    }
    console.log('Sign in successful:', data);
    return data;
  } catch (err) {
    console.error('Sign in failed:', err);
    throw err;
  }
}

export async function signOut() {
  try {
    console.log('Attempting to sign out user');
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error('Sign out error:', error);
      throw error;
    }
    console.log('Sign out successful');
    return true;
  } catch (err) {
    console.error('Sign out failed:', err);
    throw err;
  }
}

export async function getCurrentUser() {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error) throw error;
    return user;
  } catch (err) {
    console.error('Get current user error:', err);
    return null;
  }
}

export async function getSession() {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) throw error;
    return session;
  } catch (err) {
    console.error('Get session error:', err);
    return null;
  }
}